import Model from '@/models/Model'

export default class SlSaleTicket extends Model {

  /**
   * 
   */
  get details() {
    return this.sl_detail_sale_tickets || []
  }

  /**
   * 
   */
  set details(val) {
    return this.sl_detail_sale_tickets = val || []
  }

  /**
   * 
   */
  resource() {
    return 'sl_sale_ticket'
  }
}